const assignendpoint = (property, category) => `/api/${property}/events/categories/${category}/assign`;
const unassignendpoint = (property, category) => `/api/${property}/events/categories/${category}/unassign`;
const reorderendpoint = (property, category) => `/api/${property}/events/categories/${category}/reorder`;

export default ['api', '$rootScope', function(api, $rootScope) {
  return {
    unassignDay: (id, cat) => {
        return api.get(`${ unassignendpoint(api.property(), cat) }/day/${ id }`)
        .then(response => response.data);
    },
    unassignTreatment: (id, cat) => {
        return api.get(`${ unassignendpoint(api.property(), cat) }/treatment/${ id }`)
        .then(response => response.data);
    },
    assignDay: (id, cat, forcePrimary) => {
        if (forcePrimary){
            forcePrimary = '?forcePrimary=true';
        }
        return api.get(`${ assignendpoint(api.property(), cat) }/day/${ id }${forcePrimary || ''}`)
        .then(response => response.data);
    },
    assignTreatment: (id, cat, forcePrimary) => {
        if (forcePrimary){
            forcePrimary = '?forcePrimary=true';
        }
        return api.get(`${ assignendpoint(api.property(), cat) }/treatment/${ id }${forcePrimary || ''}`)
        .then(response => response.data);
    },
    reorderTreatments: (ids, cat) => {
        return api.post(`${ reorderendpoint(api.property(), cat) }/treatments`, ids)
        .then(response => response.data);
    },
    reorderDays: (ids, cat) => {
        return api.post(`${ reorderendpoint(api.property(), cat) }/days`, ids)
        .then(response => response.data);
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/services/category.assignment.service.js